export const selectGuestPreviews = (state) => state?.whoIsComing?.guestPreviews ?? [];
export const selectWhoIsComingOverlayOpen = ({whoIsComing}) => whoIsComing?.whosComingOverlayOpen;
